import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M0 5.218c2.2-2.087 5-3.18 8-3.18s5.8 1.093 8 3.18l-1.4 1.49C12.8 4.92 10.5 4.025 8 4.025S3.2 4.92 1.4 6.61L0 5.218Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.5 9.987c-.9-.993-2.2-1.49-3.5-1.49-1.3 0-2.6.497-3.5 1.49l-1.4-1.39C4.4 7.204 6.1 6.51 8 6.51c1.9 0 3.6.695 4.9 2.086l-1.4 1.391ZM8 13.962c.828 0 1.5-.667 1.5-1.49 0-.824-.672-1.491-1.5-1.491s-1.5.667-1.5 1.49c0 .824.672 1.49 1.5 1.49Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconComfortWiFi16 = createIcon(IconComponent);